import { useTranslation } from 'react-i18next';

import { useOpenWorkflowRewardingReportData } from '~/data/reports';
import { SavedReportSettingsType } from '~/data/reportSettings';

import { WorkflowReportBase } from '../../People/WorkflowReport/Common/WorkflowReportBase';
import { RewardingOpenWorkflowsReportConfig } from '../../People/WorkflowReport/types';

import { useRewardingOpenWorkflowReport } from './useOpenWorkflowReport';

export const OpenWorkflowRewardingReport = () => {
  const { t } = useTranslation();

  const config: RewardingOpenWorkflowsReportConfig = {
    reportType: SavedReportSettingsType.OpenWorkflowRewarding,
    dataFetchHook: useOpenWorkflowRewardingReportData,
    useReportHook: useRewardingOpenWorkflowReport,
    reportTitle: t('laOpenWorkflowsReport'),
    visibleToggles: [],
  };

  return (
    <WorkflowReportBase config={config} initialColumnVisibilityModel={{}} />
  );
};
